<template>
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      d="M11.1624 6.94358L0.770043 12.9436L0.770043 0.943573L11.1624 6.94358Z"
      fill="#A2B1C6"
    />
  </svg>
</template>

<script>
export default {
  name: 'RunIcon'
}
</script>
